import React, { useEffect, useState } from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from '../../utils/api';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { Pagination } from 'react-bootstrap';

function EnquiriesList() {
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(15);

    useEffect(() => {
        fetchEnquiries();
    }, [currentPage]);

    const fetchEnquiries = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`/accounts/enquiries?page=${currentPage}&per_page=${perPage}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setEnquiries(response.data.data);
            setTotalPages(Math.ceil(response.data.total / response.data.per_page));
            setLoading(false);
        } catch (error) {
            toast.error('Failed to fetch enquiries');
            setLoading(false);
        }
    };

    const getStatusBadgeClass = (status) => {
        const classes = {
            new: 'bg-info',
            in_progress: 'bg-warning',
            completed: 'bg-success',
            spam: 'bg-danger'
        };
        return classes[status] || 'bg-secondary';
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Enquiries List' />
                <div className="row g-3 mb-3">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle mb-0">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Status</th>
                                                <th>Created At</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {enquiries.map((enquiry) => (
                                                <tr key={enquiry.id}>
                                                    <td>#{enquiry.id}</td>
                                                    <td>{enquiry.name}</td>
                                                    <td>{enquiry.email}</td>
                                                    <td>{enquiry.phone}</td>
                                                    <td>
                                                        <span className={`badge ${getStatusBadgeClass(enquiry.status)}`}>
                                                            {enquiry.status?.replace('_', ' ')}
                                                        </span>
                                                    </td>
                                                    <td>{new Date(enquiry.created_at).toLocaleDateString()}</td>
                                                    <td>
                                                        <div className="btn-group" role="group">
                                                            <Link 
                                                                to={`/accounts/enquiries/${enquiry.id}`}
                                                                className="btn btn-outline-secondary btn-warning"
                                                            >
                                                                <i className="icofont-eye"></i>
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex justify-content-center mt-3">
                                    <Pagination>
                                        <Pagination.First 
                                            onClick={() => handlePageChange(1)} 
                                            disabled={currentPage === 1}
                                        />
                                        <Pagination.Prev 
                                            onClick={() => handlePageChange(currentPage - 1)} 
                                            disabled={currentPage === 1}
                                        />
                                        
                                        {[...Array(totalPages)].map((_, idx) => (
                                            <Pagination.Item
                                                key={idx + 1}
                                                active={idx + 1 === currentPage}
                                                onClick={() => handlePageChange(idx + 1)}
                                            >
                                                {idx + 1}
                                            </Pagination.Item>
                                        ))}
                                        
                                        <Pagination.Next 
                                            onClick={() => handlePageChange(currentPage + 1)} 
                                            disabled={currentPage === totalPages}
                                        />
                                        <Pagination.Last 
                                            onClick={() => handlePageChange(totalPages)} 
                                            disabled={currentPage === totalPages}
                                        />
                                    </Pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnquiriesList;